<template>

	<div>
		<div class="container">
			<div class="content">
				<section class="join">
					<h2 class="tit_page">회원가입</h2>
					<form id="frm" @submit.prevent="doJoin">
						<div class="join_form">
							<div class="form_row">
								<label for="id" class="lab">아이디 <span>*</span></label>
								<input id="id" name="id" type="email" placeholder="이메일 형식" v-model="coAccountVO.coEmailId" required="required" class="inp" :disabled="coAccountVO.snsService === 'apple'" :style="coAccountVO.snsService === 'apple' ? 'background-color: #f6f6f6' : ''">
								<p class="info_text">작성된 이메일로 최종 인증메일이 발송됩니다.</p>
							</div>
							<div class="form_row" v-if="coAccountVO.caidx <= 0">
								<label for="password" class="lab">비밀번호 <span>*</span></label>
								<input type="password" placeholder="8자 이상 영문, 숫자, 특수문자 포함" v-model="coAccountVO.passwd" id="password" class="inp">
								<p class="error_text" v-show="!$options.filters.isEmpty(coAccountVO.passwd) && coAccountVO.passwd.length<8">비밀번호가 8자리 이상이 아닙니다. 다시 입력해 주세요.</p>
							</div>
							<div class="form_row" v-if="coAccountVO.caidx <= 0">
								<label for="passwordCheck" class="lab">비밀번호 확인 <span>*</span></label>
								<input type="password" placeholder="비밀번호 확인" v-model="coAccountVO.passchk" id="passwordCheck" class="inp">
								<p class="error_text" v-show="!$options.filters.isEmpty(coAccountVO.passchk) && coAccountVO.passwd !== coAccountVO.passchk">비밀번호가 일치하지 않습니다. 다시 입력해 주세요.</p>
							</div>
							<div class="form_row">
								<label for="name" class="lab">이름 <span>*</span></label>
								<input type="text" placeholder="이름" id="name" class="inp" v-model="coAccountVO.userName" maxlength="20" required="required" :disabled="coAccountVO.snsService === 'apple'" :style="coAccountVO.snsService === 'apple' ? 'background-color: #f6f6f6' : ''">
							</div>
							<div class="form_row">
								<label for="nickname" class="lab">닉네임 <span>*</span></label>
								<input type="text" placeholder="닉네임" id="nickname" class="inp" v-model="coAccountVO.nickName" maxlength="20" required="required">
							</div>
							<div class="form_row">
								<label for="phone" class="lab">휴대전화 <span>*</span></label>
								<input type="tel" placeholder="휴대전화" id="phone" class="inp" name="phoneNo2" v-model="coAccountVO.phone" @keyup="numberUtils.setOnlyNum('phoneNo2')" required="required">
								<p class="error_text" v-show="!$options.filters.isEmpty(coAccountVO.phone) && (coAccountVO.phone.length !== 11)">올바른 휴대폰 번호가 아닙니다.</p>
							</div>
							<div class="form_row">
								<label for="company" class="lab">회사명 <span>*</span></label>
								<input type="text" placeholder="회사명" id="company" class="inp" v-model="coAccountVO.companyName" maxlength="50" required="required">
							</div>
							<div class="form_row">
								<!--						<label class="label" for="companyName">회사명</label>-->
								<!--						<div class="inp-set">-->
								<!--							<input id="companyName" name="companyName" type="text" placeholder="회사명" v-model="coAccountVO.companyName" maxlength="50" required="required">-->
								<!--						</div>-->
								<label class="lab">소속 <span v-if="!isTeamCodeNull">*</span></label>
								<SearchableSelectBox
									ref="searchableSelectBox"
									:placeholder="'부서/직위/직책'"
									:themeColor="'#ffffff'"
									:fontColor="'#3f3f3f'"
									:model="teamCodeModel"
									:valueIfNotFound="''"
									:searchTextLengthConditions4displayingLists="0"
									@getKey="getTeamCode"
									:id="'search-2'"
									:disabled="isTeamCodeNull"
									:spacing="true"
									:withTree="true"
									:additionalClass="'inp'"
								></SearchableSelectBox>
							</div>
						</div>
						<div class="join_terms">
							<div class="terms_all">
								<input type="checkbox" name="keep" id="agreeAll" class="inp_check" :true-value="true" :false-value="false" v-model="isAllCheck">
								<label for="agreeAll" class="lab_check">전체동의</label>
							</div>
							<ul class="terms_list">
								<li>
									<input type="checkbox" name="keep" id="agree1" class="inp_check" :true-value="true" :false-value="false" v-model="coAccountVO.isUseTerms">
									<label for="agree1" class="lab_check">(필수) 이용약관 동의</label>
									<a href="javascript:;" class="m-l-5"  @click="openStaticPage(origin + '/app/statics/termsofservice')">내용보기</a>
								</li>
								<li>
									<input type="checkbox" name="keep" id="agree2" class="inp_check" :true-value="true" :false-value="false" v-model="coAccountVO.isPrivacyPolicy">
									<label for="agree2" class="lab_check">(필수) 개인정보 수집 및 이용 동의</label>
									<a href="javascript:;" class="m-l-5"  @click="openStaticPage(origin + '/app/statics/privacypolicy')">내용보기</a>
								</li>
								<li>
									<input type="checkbox" name="keep" id="agree3" class="inp_check" :true-value="true" :false-value="false" v-model="coAccountVO.isMarketing">
									<label for="agree3" class="lab_check">(선택) 교육 정보 및 이벤트, 혜택 수신 동의</label>
								</li>
							</ul>
						</div>
						<div class="join_button">
							<button type="submit" class="btn btn-lg btn_join">회원가입</button>
						</div>
					</form>
				</section>
			</div>
		</div>
	</div>

</template>

<script>
import SearchableSelectBox from "@/components/selectors/searchableSelectBox";

export default {
	name: "joinForm",
	components: {SearchableSelectBox},
	data() {
		return {
			coAccountVO: new this.CoAccountVO(),
			isAllCheck: false,
			origin: location.origin,
			teamCodeModel: [],
			isTeamCodeNull: true,
		}
	},
	created() {
		this.getAccount()
		this.getClass()
	},
	mounted() {
	},
	methods: {
		getAccount() {
			const self = this
			const caidx = this.$route.query.caidx
			if (!self.stringUtils.isEmpty(caidx)) {

				this.$eventBus.$emit("startProgress")
				this.axiosCaller.get(this, this.APIs.CO_ACCOUNT + "/", {
					caidx: caidx
				}, (res) => {
					self.$eventBus.$emit("doneProgress")
					const result = res.data
					self.coAccountVO = new self.CoAccountVO();
					self.coAccountVO.coEmailId = result.coAccountVO.coEmailId
					self.coAccountVO.userName = result.coAccountVO.userName
					self.coAccountVO.isSnsLogin = result.coAccountVO.isSnsLogin
					self.coAccountVO.snsService = result.coAccountVO.snsService
					self.coAccountVO.snsId = result.coAccountVO.snsId
					self.coAccountVO.caidx = result.coAccountVO.caidx

					self.setDefaultCoName()
				})
			} else {
				self.setDefaultCoName()
			}
		},
		doJoin(e) {

			this.$eventBus.$emit("startProgress")
			/**
			 * SNS 로그인 처리일 경우
			 * doJoin4SNS 처리 우회
			 */
			if (this.coAccountVO.caidx > 0 && !this.stringUtils.isEmpty(this.coAccountVO.snsId) && !this.stringUtils.isEmpty(this.coAccountVO.snsService)) {
				this.doJoin4SNS(e);
				return
			}

			e.preventDefault()

			//const regs = /^[A-Za-z0-9+]{8,20}/
			const regs = this.PASSWORD_REGS;
			if (!this.stringUtils.isEmpty(this.coAccountVO.passwd) && !regs.test(this.coAccountVO.passwd)) {
				this.swalUtils.gritter("새 비밀번호가 짧습니다.", "새로운 비밀번호를 영문과 숫자, 특수문자가 포함된 8 ~ 20자리 사이로 입력해주세요.", "warning", 2000)
				return;
			}

			if (this.coAccountVO.passwd !== this.coAccountVO.passchk) {
				this.$swal("비밀번호 확인", "비밀번호 확인란이 일치하지 않습니다.", "error")
				return
			}

			if (this.coAccountVO.phone.length !== 11) {
				this.$swal("전화번호 확인", "올바른 휴대폰 번호가 아닙니다.", "error")
				return
			}

			if (!this.coAccountVO.isUseTerms) {
				this.$swal("이용약관 동의 필수선택", "이용약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if (!this.coAccountVO.isPrivacyPolicy) {
				this.$swal("개인정보 수집 및 이용 동의 필수선택", "개인정보 수집 및 이용 동의 약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if ( !this.isTeamCodeNull && (this.coAccountVO.teamCode == null || this.coAccountVO.teamCode === "") ) {
				this.$swal("소속 선택", "선택된 소속이 없습니다.", "error")
				return
			}

			if (!this.coAccountVO.rateCode) {
				delete this.coAccountVO.rateCode
			}

			this.axiosCaller.post(this, this.APIs.CO_ACCOUNT + "/", this.coAccountVO, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data
				if (result.status === "ok") {
					this.coAccountVO = result.coAccountVO
					this.$router.push({
						name: "joinDone",
						query: {
							caidx: this.coAccountVO.caidx
						}
					})
				} else if (result.status === "fail") {
					this.swalUtils.gritter("처리 오류", result.msg, "warning", 3000);
				} else if (result.status === "error") {
					console.log(result.msg)
					this.swalUtils.gritter("처리 오류", "시스템 오류로 처리되지 않았습니다. 관리자에게 문의하세요", "warning", 3000);
				}
			})

		},

		doJoin4SNS(e) {

			e.preventDefault()

			if (!this.coAccountVO.isUseTerms) {
				this.$swal("이용약관 동의 필수선택", "이용약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}

			if (!this.coAccountVO.isPrivacyPolicy) {
				this.$swal("개인정보 수집 및 이용 동의 필수선택", "개인정보 수집 및 이용 동의 약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if ( !this.isTeamCodeNull && (this.coAccountVO.teamCode == null || this.coAccountVO.teamCode === "") ) {
				this.$swal("소속 선택", "선택된 소속이 없습니다.", "error")
				return
			}

			if (!this.coAccountVO.rateCode) {
				delete this.coAccountVO.rateCode
			}

			this.$eventBus.$emit("startProgress")

			if (!this.coAccountVO.rateCode) {
				delete this.coAccountVO.rateCode
			}

			this.axiosCaller.post(this, this.APIs.CO_ACCOUNT + "/sns", this.coAccountVO, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data
				if (result.status === "ok") {
					this.coAccountVO = result.coAccountVO
					this.$router.push({
						name: "joinDone",
						query: {
							caidx: this.coAccountVO.caidx
						}
					})
				} else if (result.status === "fail") {
					this.swalUtils.gritter("처리 오류", result.msg, "warning", 3000);
				} else if (result.status === "error") {
					console.log(result.msg)
					this.swalUtils.gritter("처리 오류", "시스템 오류로 처리되지 않았습니다. 관리자에게 문의하세요", "warning", 3000);
				}
			})

		},

		setDefaultCoName() {
			let self = this

			this.axiosCaller.get(this, this.APIs.CO_INFO + "/" + this.webUtils.getSubdomain(), {}, (res) => {
				const result = res.data
				console.log(result)
				if (result.status === "ok") {
					self.$nextTick(() => {
						let coNameInputJqElement = $("#company")

						self.coAccountVO.companyName = result.coInfoVO.coName

						coNameInputJqElement.prop('disabled', true)
						coNameInputJqElement.css('background-color', '#f6f6f6')
					})
				}
			})
		},

		getTeamCode(key) {
			this.coAccountVO.teamCode = key
		},

		getClass() {
			this.axiosCaller.get( this, this.APIs.CO_INFO + "/getClassTree/" + this.webUtils.getSubdomain(), {}, (res) => {

				const result = res.data
				if (result.status === "ok") {
					let codeList = result.codeList
					let tempArr = []
					let minimumLevel = Math.min.apply(null, codeList.map(e => e.codeLevel))

					this.isTeamCodeNull = codeList.length === 0

					codeList.forEach(e => {
						tempArr.push({key: e.code, value: e.codeName, space: e.codeLevel - minimumLevel})
					})

					this.teamCodeModel = tempArr
				}
			})
		}
	},
	computed: {
		allow: function () {
			return [[this.coAccountVO.isUseTerms, this.coAccountVO.isPrivacyPolicy, this.coAccountVO.isMarketing], this.isAllCheck]
		}
	},
	watch: {
		allow: function (n, o) {
			if (n[1] === o[1]) {
				this.isAllCheck = this.allow[1] = this.allow[0].every((e, i, a) => e === a[0]) && this.allow[0][0]
				if (this.allow[1]) this.coAccountVO.isUseTerms = this.coAccountVO.isPrivacyPolicy = this.coAccountVO.isMarketing = true
			} else {
				this.coAccountVO.isUseTerms = this.coAccountVO.isPrivacyPolicy = this.coAccountVO.isMarketing = this.allow[1]
			}
		}
	}
}
</script>

<style scoped>

</style>